/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import styled, { ThemedStyledFunction } from 'styled-components';
import { omit } from 'lodash';

const swallowingStyled = (
  WrappedComponent: React.ComponentType<any> | string,
  swallowProps: string[] = [],
): ThemedStyledFunction<React.ComponentType<any>, any> => {
  const Wrapper = ({ children, ...props }: any): JSX.Element => (
    <WrappedComponent {...omit(props, swallowProps)}>
      {children}
    </WrappedComponent>
  );
  return styled(Wrapper);
};

export default swallowingStyled;
